/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Participants from './participants.component';
import RequestService from '../../../service/requestService';
import {
  fetchedOrganizations,
  fetchedOrganizationsError,
  fetchExportArchiveStatus,
  fetchingOrganizations
} from '../../../actions/actions';

const getParticipants = ({ studyGid, status, sites, optionalDocPublished, search, pageSize, nextPage }) => {
  return new Promise((resolve, reject) => {
    RequestService.getParticipantsByStudy({ studyGid, status, sites, optionalDocPublished, search, pageSize, nextPage })
      .then((response) => {
        resolve({ data: response.data.participants.data, itemsCount: response.data.participants.total });
      })
      .catch(reject);
  });
};

const getOverallDetails = (studyGid, sites) => {
  return new Promise((resolve, reject) => {
    RequestService.getOverallParticipantStatus(studyGid, sites)
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};

const fetchParticipantStatuses = (/* studyGid */) => {
  return new Promise((resolve, reject) => {
    RequestService.getParticipantStatuses()
      .then((response) => {
        resolve(response);
      })
      .catch(reject);
  });
};

const fetchOrganizations = (dispatch) => (studyGid) => {
  return new Promise((resolve, reject) => {
    dispatch(fetchingOrganizations());

    return RequestService.getOrganizationsByStudy(studyGid)
      .then((response) => {
        dispatch(fetchedOrganizations(response.data));
        resolve(response.data);
      })
      .catch((error) => {
        dispatch(fetchedOrganizationsError(error));
        reject(error);
      });
  });
};

const getBatchArchivingStatus = (dispatch) => (studyGid, sites) => {
  dispatch(fetchExportArchiveStatus(studyGid, sites));
};

export default withRouter(
  connect(
    (store) => ({
      participantStudy: store.subject.participantStudy
    }),
    (dispatch) => ({
      getParticipants,
      fetchOrganizations: fetchOrganizations(dispatch),
      getOverallDetails,
      fetchParticipantStatuses,
      getBatchArchivingStatus: getBatchArchivingStatus(dispatch)
    })
  )(Participants)
);
